export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : '';
        this.message = item != null ? item.message : ''
        this.reactie = item != null ? item.reactie : ''
    }
}